module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"project_x_workflow":"{project_name} project workflow","project_x":"{project_name} project"},"fr":{"project_x_workflow":"Workflow du projet {project_name}","project_x":"Projet {project_name}"}}')
  delete Component.options._Ctor
}
